import React, { FC, memo, useCallback } from 'react';
import { handleBeginCommentIntent } from './logic';
import { Button } from './styles';
import { Props } from './types';

const NewQuestionButton: FC<Props> = ({
  beginIntent,
  disabled,
  loggedIn,
  url,
}) => {
  const onBeginCommentIntent = useCallback(
    handleBeginCommentIntent({ beginIntent, url }),
    [beginIntent, url],
  );

  if (disabled) {
    return null;
  }

  return loggedIn ? (
    <Button to="#new-question">Ask a question!</Button>
  ) : (
    <Button onClick={onBeginCommentIntent}>Ask a question!</Button>
  );
};

export default memo(NewQuestionButton);
